import { render, staticRenderFns } from "./actionbar.vue?vue&type=template&id=5cfef1fe&scoped=true&lang=html&"
import script from "./actionbar.vue?vue&type=script&lang=js&"
export * from "./actionbar.vue?vue&type=script&lang=js&"
import style0 from "./actionbar.vue?vue&type=style&index=0&id=5cfef1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfef1fe",
  null
  
)

export default component.exports